// extracted by mini-css-extract-plugin
module.exports = {"ForgotPassword":"ForgotPassword_ForgotPassword__2Txcs","ForgotPasswordParent":"ForgotPassword_ForgotPasswordParent__11jni"};